// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Link = require("next/link").default;
var AuthSession = require("../../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var NotificationsAndAlertsUtilsAgent_agent_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsAgent_agent_graphql.bs.js");
var NotificationsAndAlertsUtilsAgent_agentId_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsAgent_agentId_graphql.bs.js");
var NotificationsAndAlertsUtilsForSale_agent_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsForSale_agent_graphql.bs.js");
var NotificationsAndAlertsUtilsForSale_agentId_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsForSale_agentId_graphql.bs.js");
var NotificationsAndAlertsUtilsClientLabel_client_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsClientLabel_client_graphql.bs.js");
var NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql.bs.js");

var convertFragment = NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql.node, convertFragment, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql.node, convertFragment, fRef);
}

var LocationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  readInline: readInline
};

function getLabel($$location, withLinksOpt) {
  var withLinks = withLinksOpt !== undefined ? withLinksOpt : false;
  var $$location$1 = readInline($$location);
  var match = $$location$1.propertyLocation;
  var text;
  if (match !== undefined) {
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
          var locationDisplay = match.locationDisplay;
          text = locationDisplay !== undefined ? locationDisplay : "-";
          break;
      case "PropertyLocationWithVisibleAddress" :
          var locationDisplay$1 = match.address;
          text = locationDisplay$1 !== undefined ? locationDisplay$1 : "-";
          break;
      case "__unselected" :
          text = "-";
          break;
      
    }
  } else {
    text = "-";
  }
  if (withLinks) {
    return JsxRuntime.jsx(Link, {
                href: "/properties/" + $$location$1.id,
                children: Caml_option.some(text)
              });
  } else {
    return text;
  }
}

var PropertyLocationLabel = {
  LocationFragment: LocationFragment,
  getLabel: getLabel
};

var convertFragment$1 = NotificationsAndAlertsUtilsClientLabel_client_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsClientLabel_client_graphql.node, convertFragment$1, fRef);
}

function readInline$1(fRef) {
  return RescriptRelay_Fragment.readInlineData(NotificationsAndAlertsUtilsClientLabel_client_graphql.node, convertFragment$1, fRef);
}

var ClientFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  readInline: readInline$1
};

function getLabel$1(client, withLinksOpt) {
  var withLinks = withLinksOpt !== undefined ? withLinksOpt : false;
  var client$1 = readInline$1(client);
  if (withLinks) {
    return JsxRuntime.jsx(Link, {
                href: "/clients/" + client$1.id,
                children: Caml_option.some(client$1.displayName)
              });
  } else {
    return client$1.displayName;
  }
}

var ClientLabel = {
  ClientFragment: ClientFragment,
  getLabel: getLabel$1
};

var convertFragment$2 = NotificationsAndAlertsUtilsAgent_agent_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsAgent_agent_graphql.node, convertFragment$2, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsAgent_agent_graphql.node, convertFragment$2, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationsAndAlertsUtilsAgent_agent_graphql.node, convertFragment$2);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationsAndAlertsUtilsAgent_agent_graphql.node, convertFragment$2, fRef);
}

var Agent = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function useAgentTextOpt(fragmentRefs, withLinksOpt) {
  var withLinks = withLinksOpt !== undefined ? withLinksOpt : false;
  var currentUserId = AuthSession.useCurrentUserId();
  var data = useOpt(fragmentRefs);
  if (data === undefined) {
    return "A TAN agent";
  }
  var agentId = data.id;
  var displayName = data.displayName;
  if (currentUserId !== undefined && currentUserId === agentId) {
    return "You";
  }
  if (withLinks) {
    return JsxRuntime.jsx(Link, {
                href: "/agents/" + agentId,
                children: Caml_option.some(displayName)
              });
  } else {
    return displayName;
  }
}

function useAgentText(fragmentRefs, withLinksOpt) {
  var withLinks = withLinksOpt !== undefined ? withLinksOpt : false;
  return useAgentTextOpt(Caml_option.some(fragmentRefs), withLinks);
}

var convertFragment$3 = NotificationsAndAlertsUtilsForSale_agent_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsForSale_agent_graphql.node, convertFragment$3, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsForSale_agent_graphql.node, convertFragment$3, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationsAndAlertsUtilsForSale_agent_graphql.node, convertFragment$3);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationsAndAlertsUtilsForSale_agent_graphql.node, convertFragment$3, fRef);
}

var ForSaleAgent = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useForSaleAgentText(fragmentRefs) {
  var data = use$1(fragmentRefs);
  var fragmentRef;
  switch (data.__typename) {
    case "VisibleForSalePropertyAgent" :
        var match = data.agent;
        fragmentRef = match !== undefined ? Caml_option.some(match.fragmentRefs) : undefined;
        break;
    case "AnonymousForSalePropertyAgent" :
    case "__unselected" :
        fragmentRef = undefined;
        break;
    
  }
  var text = useAgentTextOpt(fragmentRef, undefined);
  switch (data.__typename) {
    case "AnonymousForSalePropertyAgent" :
        return "A TAN agent";
    case "VisibleForSalePropertyAgent" :
    case "__unselected" :
        return text;
    
  }
}

var AgentText = {
  Agent: Agent,
  useAgentTextOpt: useAgentTextOpt,
  useAgentText: useAgentText,
  ForSaleAgent: ForSaleAgent,
  useForSaleAgentText: useForSaleAgentText
};

var convertFragment$4 = NotificationsAndAlertsUtilsAgent_agentId_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsAgent_agentId_graphql.node, convertFragment$4, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsAgent_agentId_graphql.node, convertFragment$4, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationsAndAlertsUtilsAgent_agentId_graphql.node, convertFragment$4);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationsAndAlertsUtilsAgent_agentId_graphql.node, convertFragment$4, fRef);
}

var Agent$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function useAgentId(fragmentRefs) {
  return use$2(fragmentRefs).id;
}

var convertFragment$5 = NotificationsAndAlertsUtilsForSale_agentId_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsForSale_agentId_graphql.node, convertFragment$5, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsForSale_agentId_graphql.node, convertFragment$5, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationsAndAlertsUtilsForSale_agentId_graphql.node, convertFragment$5);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(NotificationsAndAlertsUtilsForSale_agentId_graphql.node, convertFragment$5, fRef);
}

var ForSaleAgent$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function useForSaleAgentId(fragmentRefs) {
  var data = use$3(fragmentRefs);
  if (data.__typename !== "VisibleForSalePropertyAgent") {
    return ;
  }
  var match = data.agent;
  if (match !== undefined) {
    return match.id;
  }
  
}

var AgentId = {
  Agent: Agent$1,
  useAgentId: useAgentId,
  ForSaleAgent: ForSaleAgent$1,
  useForSaleAgentId: useForSaleAgentId
};

exports.PropertyLocationLabel = PropertyLocationLabel;
exports.ClientLabel = ClientLabel;
exports.AgentText = AgentText;
exports.AgentId = AgentId;
/* next/link Not a pure module */
